import { useGenomeViewerStore } from "../../store/store.ts";
import { handleKeyDown, handleKeyUp } from "./handle-keyboard-events.ts";
import {
  handlePointerCancel,
  handlePointerDown,
  handlePointerMove,
  handlePointerUp,
  handleScrollbarMouseMove,
  handleScrollbarMouseUp,
  handleWheel,
} from "./handle-pointer-events.ts";

/**
 * Pointer/Mouse events on the main canvas
 */
export function setupUserEventListeners() {
  const state = useGenomeViewerStore.getState();
  document.addEventListener("keydown", handleKeyDown);
  document.addEventListener("keyup", handleKeyUp);
  document.addEventListener("pointermove", handleScrollbarMouseMove);
  document.addEventListener("pointerup", handleScrollbarMouseUp);

  state.canvas!.addEventListener("wheel", handleWheel);
  state.canvas!.addEventListener("pointerdown", handlePointerDown);
  state.canvas!.addEventListener("pointermove", handlePointerMove);
  state.canvas!.addEventListener("pointerup", handlePointerUp);
  state.canvas!.addEventListener("pointercancel", handlePointerCancel);
  state.canvas!.addEventListener("contextmenu", (e) => {
    e.preventDefault();
  });
}

export function disableUserEventListeners() {
  const state = useGenomeViewerStore.getState();
  document.removeEventListener("keydown", handleKeyDown);
  document.removeEventListener("keyup", handleKeyUp);
  document.removeEventListener("pointermove", handleScrollbarMouseMove);
  document.removeEventListener("pointerup", handleScrollbarMouseUp);

  state.canvas!.removeEventListener("wheel", handleWheel);
  state.canvas!.removeEventListener("pointerdown", handlePointerDown);
  state.canvas!.removeEventListener("pointermove", handlePointerMove);
  state.canvas!.removeEventListener("pointerup", handlePointerUp);
  state.canvas!.removeEventListener("pointercancel", handlePointerCancel);
  state.canvas!.removeEventListener("contextmenu", (e) => {
    e.preventDefault();
  });
}
